import { combineReducers } from 'redux';

// Reducers for the application
import shared from './shared';
import fwf from './fwf';
import location from './location';
import user from './user';

const reducers = {
  shared,
  fwf,
  location,
  user,
};

export default combineReducers(reducers);
